import { RefObject, useEffect } from "react";
interface UseBlurOnChipBlurProps<ElementType extends HTMLElement> {
    activeIndex: number;
    ref: RefObject<ElementType>;
    setActiveIndex: (index: number) => void;
}
type UseChipBlurHook = <ElementType extends HTMLElement>(props: UseBlurOnChipBlurProps<ElementType>) => void;

export const useBlurOnChipBlur: UseChipBlurHook = ({ ref, activeIndex, setActiveIndex }) => {
    useEffect(() => {
        const manageBlur = (e: MouseEvent) => {
            if (!ref.current?.contains(e.target as Node) && activeIndex > -1) {
                /* NOTE: -2 is a hack to get around downshift's automatic refocusing of the dropdown
                 * element when activeIndex is set to -1. We need to do this to blur all chips when
                 * the multiselect is blurred.
                 *
                 * See: https://github.com/downshift-js/downshift/blob/master/src/hooks/useMultipleSelection/index.js#L87
                 */

                setActiveIndex(-2);
            }
        };
        document.addEventListener("click", manageBlur);
        return () => {
            document.removeEventListener("click", manageBlur);
        };
    }, [ref, activeIndex, setActiveIndex]);
};
